// eslint-disable-next-line import/prefer-default-export
export const sortOrganizations = (organizations) => {
  return organizations.sort((a, b) => a.label.localeCompare(b.label));
};
